import React from "react";
import { CgLogIn } from 'react-icons/cg';
import Multiselect from 'multiselect-react-dropdown';


// 
export default function AddLeadModal(props) {


  let { addLeadModal, handleCreditActivityHideModal, errorsQuote, inputAddUserChange, createLeadSubmit, fieldsQuote, getAllUser,
    // options,
    selectedValue, onSelect, onRemove, getAllCategory, onUserSelect, onUserRemove,
    // handleSelectedTag, selectedTag
  } = props;

  let categoryData = [];
  if (getAllCategory && getAllCategory.length > 0) {
    getAllCategory.forEach((event) => {
      categoryData.push(
        {
          name: event.name,
          id: event.id,
        }
      )
    })
  }

  let userData = [];
  if (getAllUser && getAllUser.length > 0) {
    getAllUser.forEach((event) => {
      userData.push(
        {
          userName: event.userName,
          email: event.email,
          id: event._id,
        }
      )
    })
  }


  console.log('userData____MODAL______________', userData);
  // console.log('optionsMODAL______________', getAllCategory);
  // console.log('getAllCategoryMODAL______________', getAllCategory);
  // console.log('categoryDataMODAL______________', categoryData);


  // options: [{name: 'Option 1️⃣', id: 1},{name: 'Option 2️⃣', id: 2}]

  return (

    <div className={addLeadModal ? "fixed w-full lg:left-24 left-0 h-full inset-0 z-40 overflow-hidden mt-0 flex justify-center items-center overflow-y-auto bg-black/40 md:p-0 p-1" : "hidden"} style={{ marginTop: '0rem', }}  >
      <div className="animate__animated animate__fadeInDown animate__faster bg-[#f8f8fb] md:w-[38rem] w-full mx-auto rounded shadow-lg overflow-y-auto mt-2">
        {/*modal header*/}
        <div className="flex items-center justify-between p-6 py-2 bg-blue-500 border-b">
          <p className="text-[16px] lg:px-0 px-12 font-medium text-white uppercase">Add Lead</p>
          <div className="rounded-full cursor-pointer modal-close ">
            <svg onClick={() => handleCreditActivityHideModal()} className="fill-current text-white/60 hover:text-white/100" xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 18 18">
              <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z">
              </path>
            </svg>
          </div>
        </div>

        <div className="p-4">
          <button className="text-sm text-gray-600 font-medium p-4 py-2 border border-gray-300 border-b-transparent bg-white -mb-0.5">
            Create Lead
          </button>
          <form autoComplete="off" className="p-4 space-y-4 capitalize border border-gray-300 ">
            <div className="grid grid-cols-1 gap-3 lg:grid-cols-2">
              <div className="w-full">
                <label className="block text-xs font-medium text-gray-500 md:text-left" for="username">Name :</label>
                <input className={`w-full p-2 mt-1 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 ring-gray-500   ${errorsQuote && !errorsQuote["name"] ? "border  placeholder-gray-500" : "border border-red-500 "}`}
                  id="name" name="name" placeholder="Name..." type="text" value={fieldsQuote && fieldsQuote.name ? fieldsQuote.name : ""} onChange={inputAddUserChange} />
                {errorsQuote && errorsQuote["name"] ?
                  <div className="text-xs text-red-500 invalid-feedback">
                    {errorsQuote["name"]}
                  </div>
                  : null}
              </div>

              <div className="w-full">
                <label className="block text-xs font-medium text-gray-500 md:text-left" for="username">Date :</label>
                <input className={` w-full p-2 mt-1 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 ring-gray-500  ${errorsQuote && !errorsQuote["calenderDate"] ? "border  placeholder-gray-500" : "border border-red-500 "}`}
                  id="calenderDate" name="calenderDate" placeholder="Date..." type="date" value={fieldsQuote && fieldsQuote.calenderDate ? fieldsQuote.calenderDate : ""} onChange={inputAddUserChange} />
                {errorsQuote && errorsQuote["calenderDate"] ?
                  <div className="text-xs text-red-500 invalid-feedback">
                    {errorsQuote["calenderDate"]}
                  </div>
                  : null}
              </div>

              <div className="w-full">
                <label className="block text-xs font-medium text-gray-500 md:text-left" for="username">Requirement :</label>
                <input className={` w-full p-2 mt-1 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 ring-gray-500  ${errorsQuote && !errorsQuote["requirement"] ? "border  placeholder-gray-500" : "border border-red-500 "}`}
                  id="requirement" name="requirement" placeholder="Requirement..." type="text" value={fieldsQuote && fieldsQuote.requirement ? fieldsQuote.requirement : ""} onChange={inputAddUserChange} />
                {errorsQuote && errorsQuote["requirement"] ?
                  <div className="text-xs text-red-500 invalid-feedback">
                    {errorsQuote["requirement"]}
                  </div>
                  : null}
              </div>
              <div className="w-full">
                <label className="block text-xs font-medium text-gray-500 md:text-left" for="username">Select Category List :</label>
                <select id="countries" class="bg-gray-50 border border-gray-300 text-gray-400 text-sm rounded-lg focus:ring-gray-500 focus:border-gray-500 block w-full px-6 py-3 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-gray-500 dark:focus:border-gray-500 outline-none"
                  name="source"
                  onChange={inputAddUserChange}
                >
                  <option selected>Choose a country</option>
                  <option value="Facebook">Facebook</option>
                  <option value="LinkedIn">LinkedIn</option>
                  <option value="Comfygen">Comfygen</option>
                </select>
              </div>
              <div className="w-full">
                <label className="block text-xs font-medium text-gray-500 md:text-left" for="username">Select Category List :</label>
                <Multiselect
                  options={categoryData} // Options to display in the dropdown
                  selectedValues={selectedValue} // Preselected value to persist in dropdown
                  onSelect={onSelect} // Function will trigger on select event
                  onRemove={onRemove} // Function will trigger on remove event
                  displayValue="name" // Property name to display in the dropdown options
                />
              </div>

              <div className="w-full">
                <label className="block text-xs font-medium text-gray-500 md:text-left" for="username">User List :</label>
                <Multiselect
                  options={userData} // Options to display in the dropdown
                  selectedValues={selectedValue} // Preselected value to persist in dropdown
                  onSelect={onUserSelect} // Function will trigger on select event
                  onRemove={onUserRemove} // Function will trigger on remove event
                  displayValue="userName" // Property name to display in the dropdown options
                />
              </div>
            </div>
            <div className="flex justify-end py-0 space-x-4">
              <button className="bg-blue-500  transition duration-150 text-white text-[.8125rem]  px-3 py-2 rounded-[.25rem] flex items-center hover:bg-[#f14646] " type="button"
                onClick={() => createLeadSubmit()}>Submit
                <CgLogIn size={18} className="ml-2" />
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>



  );
}
